import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.6 }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.95 }}
    className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full bg-gold-metal pl-4 pr-5 py-3.5 text-[#0B132B] shadow-[0_10px_40px_-8px_rgba(212,175,55,0.6)]"
    aria-label="Falar no WhatsApp"
  >
    <span className="relative flex">
      <span className="absolute inset-0 rounded-full bg-[#0B132B]/30 animate-ping" />
      <MessageCircle className="relative w-5 h-5" />
    </span>
    <span className="hidden sm:inline text-sm font-semibold">Fale com um especialista</span>
  </motion.a>
);
